<template>
  <div class="fixed-sidebar">
    <div>
      <el-tooltip content="Home" placement="left">
        <el-button class="sidebar-button" circle @click="redirectPage('/')" type="warning">
          <i class="fas icon-fa-home" style="font-size: 1.2em"></i>
        </el-button>
      </el-tooltip>
    </div>
    <!-- <div>
      <el-tooltip content="Genomes Page" placement="left">
        <el-button class="sidebar-button" circle type="success" @click="redirectPage('genomes')">
          <i class="fas icon-fa-virus" style="font-size: 1.2em"></i>
        </el-button>
      </el-tooltip>
    </div> -->
    <!-- <div>
      <el-tooltip content="Mutations Page" placement="left">
        <el-button class="sidebar-button" circle type="primary" @click="redirectPage('variants')" style="height: 2.6em; width: 2.6em">
          <i class="fas icon-fa-dna" style="font-size: 1.2em;"></i>
        </el-button>
      </el-tooltip>
    </div> -->
    <!-- <div>
      <el-tooltip content="Shared Mutations Page" placement="left">
        <el-button class="sidebar-button" circle type="primary" @click="redirectPage('covariants')" style="height: 2.6em; width: 2.6em">
          <span class="icon-fa-stack icon-fa-2x" style="height: 48px; width: 48px; top: -32px; left: -14px">
            <i class="fas icon-fa-dna icon-fa-inverse" style="font-size: 0.6em"></i>
            <i class="fas icon-fa-plus-square icon-fa-stack-1x icon-fa-inverse" 
               style="font-size: 0.4em; left: 10px; top: 4px"></i>
          </span>
        </el-button>
      </el-tooltip>
    </div> -->
    <!-- <div>
      <el-tooltip content="State Page" placement="left">
        <el-button class="sidebar-button" circle type="danger" @click="redirectPage('state')" style="height: 2.6em; width: 2.6em">
          <i class="fas icon-fa-map-marked-alt" style="font-size: 1.2em;"></i>
        </el-button>
      </el-tooltip>
    </div> -->
    <!-- //!this was already commented out -->
    <!-- <div>
      <el-tooltip content="Reinfection Page" placement="left">
        <el-button class="sidebar-button" circle type="info" @click="redirectPage('reinfection')"
          style="height: 48px; width: 48px">
          <span class="icon-fa-stack icon-fa-2x" style="height: 48px; width: 48px; top: -30px; left: -12px">
            <i class="fas icon-fa-head-side-virus" style="font-size: 0.6em; color: #004c6d"></i>
            <i class="fas icon-fa-sync icon-fa-stack-1x icon-fa-inverse" style="font-size: 0.3em; top: -5px; left: 8px; height: 12px;"></i>
          </span>
        </el-button>
      </el-tooltip>
    </div> -->
    <div>
      <el-tooltip content="Settings Panel" placement="left">
        <el-button class="sidebar-button" circle type="plain" @click="openModal('SettingsPanel')">
          <i class="fas icon-fa-cog" style="font-size: 1.2em;"></i>
        </el-button>
      </el-tooltip>
    </div>
    <div>
      <el-tooltip content="Nextstrain Analysis" placement="left">
        <div class="sidebar-button" circle style="padding: 0px; border: none;">
          <a href="https://data.ccmb.res.in/gear19/auspice" target="_blank" style="height: 2.4em;">
          <img class="nextstrain-logo" src="../assets/nextstrain.png" style="height: 2.4em;"></a>
        </div>
      </el-tooltip>
    </div>
    <div>
      <el-tooltip :content="`${store.theme.viewMode.tooltip[store.theme.viewMode.active]}`" placement="left">
        <el-button class="sidebar-button" @click="viewModeChange" circle :style="`border: none; 
          background-color: ${store.theme.viewMode.iconBackgroundColor[store.theme.viewMode.active]}; 
          color: ${store.theme.viewMode.iconColor[store.theme.viewMode.active]}`">
          <i :class="`${store.theme.viewMode.icons[store.theme.viewMode.active]}`" style="font-size: 1.2em"></i>
        </el-button>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import { store } from '@/scripts/store.js'

export default {
  name: 'SideIcons',
  data() {
    return { 
      store
    }
  },
  methods: {
    openModal(val) {
      store.modal.openModal(val);
    },
    redirectPage: function (path) {
      this.$router.push(path)
    },
    viewModeChange: function() {
      console.log('View mode changed')
      this.store.theme.viewMode.change()
    }
  }
}
</script>

<style scoped>

@keyframes spin {
    from {transform:rotate(0deg);}
    to {transform:rotate(720deg);}
}

@keyframes spinout {
    from {transform:rotate(0deg);}
    to {transform:rotate(-720deg);}
}

.fixed-sidebar {
  position: fixed;
  right: 50px;
  top: 100px;
  color: black;
  z-index: 1000;
}

.fixed-sidebar div {
  padding-top: 1em;
}

.sidebar-button {
  font-size: 1.2em;
}

.nextstrain-logo {
  animation-name: spinout;
  animation-duration: 300ms;
  animation-timing-function: ease-in-out;
}


.nextstrain-logo:hover {
  animation-name: spin;
  animation-duration: 300ms;
  animation-timing-function: ease-in-out;
}

 @media (max-width: 992px) {
   .fixed-sidebar {
      display: none;
    }
  }
</style>